/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Limits_Starter_UsersInputs */



/**
* | output |
* | --- |
* | "Up to 5" |
*
* @param {Compare_Limits_Starter_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_limits_starter_users = /** @type {((inputs?: Compare_Limits_Starter_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Limits_Starter_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bis zu 5")
	return /** @type {LocalizedString} */ ("Up to 5")
});